import { msg } from '@lingui/core/macro';

// Shared DE loan-application option constants (values + i18n labels)
export const LOAN_DURATION_OPTIONS_DE = [
  {
    label: msg`Short term: just a few months`,
    value: 'few_months',
  },
  {
    label: msg`Medium term: 1-2 years`,
    value: 'one_to_two_years',
  },
  {
    label: msg`Long term: 3-5 years`,
    value: 'three_plus_years',
  },
  {
    label: msg`Flexible: access money as needed`,
    value: 'ongoing',
  },
] as const;

export const LOAN_PURPOSE_OPTIONS_DE = [
  {
    label: msg`Stock purchase`,
    value: 'stock_purchase',
  },
  {
    label: msg`Bridging loan`,
    value: 'bridging_loan',
  },
  {
    label: msg`Pay bill`,
    value: 'pay_bill',
  },
  {
    label: msg`Equipment purchase`,
    value: 'equipment_purchase',
  },
  {
    label: msg`Financing client order`,
    value: 'financing_client_order',
  },
  {
    label: msg`Pay tax bill`,
    value: 'pay_tax_bill',
  },
  {
    label: msg`Refinancing debt`,
    value: 'refinancing_debt',
  },
  {
    label: msg`Pay wages`,
    value: 'pay_staff',
  },
  {
    label: msg`Marketing`,
    value: 'marketing',
  },
  {
    label: msg`Other`,
    value: 'other',
  },
] as const;
